import { cn } from '@rematter/ui-web/lib';
import { LucideAsterisk, LucideCheck } from 'lucide-react';

type Props = {
  name?: string;
  isRequired?: boolean;
  isCompleted?: boolean;
};

export const RequirementTag = ({ name, isRequired, isCompleted }: Props) => (
  <div
    className={cn(
      '@RequirementTag',
      'flex max-w-fit items-center gap-2 rounded bg-neutral/5 px-2.5 py-1 text-neutral/60',
      {
        'bg-success/10 text-success-darker': isCompleted,
      },
    )}
  >
    <div aria-required={isRequired}>{name}</div>
    {isCompleted && <LucideCheck className="size-4 text-success/80" />}
    {isRequired && !isCompleted && (
      <LucideAsterisk className="size-4 text-failure/80" />
    )}
  </div>
);
